import React from 'react';
import { useUserContext } from '../../../common/utils';
import { formatTemperature } from '../../../common/utils/utils';
import { Label } from '../../components';

const MachineTemperature = ({
	temperature = null,
}) => {
	const { tenantSettings } = useUserContext();
	const [minThreshold, maxThreshold] = tenantSettings?.temperatureThresholds || [];

	if (temperature !== null) {
		const formattedTemp = parseFloat(temperature / 100, 10);
		const isWithinLimits = formattedTemp >= minThreshold && formattedTemp <= maxThreshold;

		return (
			<Label
				red={!isWithinLimits}
				green={isWithinLimits}
				label={formatTemperature(temperature)}
			/>
		);
	}

	return null;
};

export default MachineTemperature;
